export default {
  emptyDraftsListTitle: 'Aquí encontrarás el contenido que se encuentre en proceso de creación',
  emptyPublishedListTitle: 'Aquí encontrarás el contenido que ya hayas creado y publicado',
  hasDraftsListTitle: 'Tienes contenido para terminar de crear',
  resumeEdition: 'Continuar creando',
  createContent: 'Crear contenido'
}

export const en = {
  emptyDraftsListTitle: 'Here you will find content that is in the process of being created.',
  emptyPublishedListTitle: 'Here you will find the content you have already created and posted.',
  hasDraftsListTitle: 'You have content to finish creating',
  resumeEdition: 'Continue creating',
  createContent: 'Create content'
}

export const ca = {
  emptyDraftsListTitle: 'Aquí trobaràs el contingut que es trobi en procés de creació',
  emptyPublishedListTitle: 'Aquí trobaràs el contingut que ja hagis creat i publicat',
  hasDraftsListTitle: 'Tens contingut per acabar de crear',
  resumeEdition: 'Continuar creant',
  createContent: 'Crear contingut'
}
